export default "__VITE_ASSET__2Mme3g1O__"